import { Card, Typography } from 'antd'
import { approverName } from './HRDashboard'
import { hasObjectiveText } from './useFormStructure'

const { Text } = Typography

export default function ManagerFeedback({ appraisal, formData, formStructure, objectives, formConfig, ratingDisplay, authorName = approverName(appraisal, 1) }) {
    const displayValue = value => {
        if (value === null || value === undefined || value === '') return 'Not provided'
        return ratingDisplay(value) || `${value}`
    }
    const cultureValues = formData.hong_kong_culture_values || {}
    const cultureConfig = formConfig?.appraisal_form?.hong_kong_sections?.culture_values || {}
    const managerRatingField = formConfig?.appraisal_form?.overall_rating_field || 'manager_overall_rating'
    const summaryRatings = [
        ['Overall Objective Rating', formData.manager_objective_overall_rating],
        ['Overall Competency Rating', formData.manager_competency_overall_rating],
        [
            'Overall Performance Rating',
            formData[managerRatingField] ??
            formData.manager_overall_performance_rating ??
            formData.checkbox_flow?.overall_performance_rating
        ]
    ].filter(([, value]) => value !== null && value !== undefined && value !== '')

    return (
        <Card
            title={<Text style={{ color: '#FFF' }}>Feedback from {authorName}</Text>}
            style={{ marginBottom: 24, borderColor: '#faad14' }}
        >
            {objectives.filter(hasObjectiveText).map((objective, index) => (
                <div key={`objective-${index}`} style={{ marginBottom: 12 }}>
                    <Text strong style={{ display: 'block' }}>Objective {index + 1}: {objective.objective}</Text>
                    <Text>Rating: {displayValue(objective.manager_score)}</Text>
                    {objective.manager_comment?.trim() && (
                        <Text style={{ display: 'block', whiteSpace: 'pre-wrap', color: '#595959' }}>
                            {objective.manager_comment}
                        </Text>
                    )}
                </div>
            ))}

            {formStructure.flatMap(category => category.questions.map(question => {
                const response = formData[category.id]?.[question.id] || {}
                const normalizedCategoryTitle = (category.title || '').trim().toLocaleLowerCase()
                const normalizedQuestionText = (question.text || '').trim().toLocaleLowerCase()
                const feedbackLabel = normalizedCategoryTitle === normalizedQuestionText
                    ? question.text
                    : `${category.title}: ${question.text}`
                return (
                    <div key={`${category.id}-${question.id}`} style={{ marginBottom: 12 }}>
                        <Text strong style={{ display: 'block' }}>{feedbackLabel}</Text>
                        <Text>Rating: {displayValue(response.manager_rating)}</Text>
                        {response.manager_comments?.trim() && (
                            <Text style={{ display: 'block', whiteSpace: 'pre-wrap', color: '#595959' }}>
                                {response.manager_comments}
                            </Text>
                        )}
                    </div>
                )
            }))}

            {(cultureConfig.values || [])
                .filter(value => cultureValues[value.key]?.selected)
                .map(value => (
                    <div key={value.key} style={{ marginBottom: 12 }}>
                        <Text strong style={{ display: 'block' }}>{value.label}</Text>
                        {cultureValues[value.key]?.manager_comment?.trim() && (
                            <Text style={{ whiteSpace: 'pre-wrap', color: '#595959' }}>
                                {cultureValues[value.key].manager_comment}
                            </Text>
                        )}
                    </div>
                ))}

            {summaryRatings.map(([label, value]) => (
                <div key={label} style={{ marginBottom: 8 }}>
                    <Text strong>{label}:</Text> <Text>{displayValue(value)}</Text>
                </div>
            ))}

            {formData.manager_overall_rating_justification && (
                <div style={{ marginBottom: 8 }}>
                    <Text strong style={{ display: 'block' }}>Rating Justification</Text>
                    <Text style={{ whiteSpace: 'pre-wrap' }}>{formData.manager_overall_rating_justification}</Text>
                </div>
            )}
            {formData.prc_idp?.supervisor_year_end_suggestion && (
                <div style={{ marginBottom: 8 }}>
                    <Text strong style={{ display: 'block' }}>Supervisor Year-End Suggestion</Text>
                    <Text style={{ whiteSpace: 'pre-wrap' }}>{formData.prc_idp.supervisor_year_end_suggestion}</Text>
                </div>
            )}
            {appraisal.manager_overall_comment?.trim() && (
                <div>
                    <Text strong style={{ display: 'block' }}>Overall Comment</Text>
                    <Text style={{ whiteSpace: 'pre-wrap' }}>{appraisal.manager_overall_comment}</Text>
                </div>
            )}
        </Card>
    )
}